
import {
    createAsyncThunk
} from "@reduxjs/toolkit";
/*
const thunk = (name, apiFunc, returnFunc) =>
    createAsyncThunk(
        name,
        async (data, {
            rejectWithValue,
            getState
        }) => await apiFunc(data).then(r => {
            return (returnFunc({
                d: data,
                r: r.data,
                getState
            }))
        }).catch(e => rejectWithValue(e))
    );
*/


const thunk = (name, apiFunc, returnFunc) =>
    createAsyncThunk(
      name,
      async (data, { rejectWithValue, getState }) => {
        try {
          
          const response = await apiFunc(data);
          return (returnFunc({
            d: data,
            r: response.data,
            getState
          }));
        } catch (error) {
          console.error("Error in thunk", name, error); // Added line to log error
          return rejectWithValue(error);
        }
      }
    );


    export default thunk;